import React from "react";
import { Box, Typography } from "@mui/material";
import { parseISO, isValid, format } from "date-fns";

interface Props {
  firstText: string;
  secondText: string;
  align?: string;
  color?: string;
  
}

// Funzione per verificare e formattare la data
const formatDateIfValid = (text?: string | null): string => {
  if (!text) return "-"; // N/D = Non Disponibile (puoi cambiarlo con un altro valore)
  
  const parsedDate = parseISO(text);
  return isValid(parsedDate) ? format(parsedDate, "dd/MM/yyyy") : text;
};

const TextDisplay: React.FC<Props> = ({ firstText, secondText, align, color }) => {
  return (
    <Box>
      <Typography
        sx={{
          fontSize: "14px",
          color: color || "#CF0A2C",
          fontWeight: "bold",
          textTransform: "uppercase",
        }}
      >
        {formatDateIfValid(firstText)}
      </Typography>
      <Typography sx={{ fontSize: "14px", textAlign: align || 'left' }}>
        {formatDateIfValid(secondText)}
      </Typography>
    </Box>
  );
};

export default TextDisplay;
